import { patchState, signalStore, withMethods, withState } from "@ngrx/signals"

export type GeneralState = {
	stripePublicKey: string,
	radarPublicKey: string,
}

export const GeneralStore = signalStore(
	{ providedIn: "root" },
	withState<GeneralState>({
		stripePublicKey: "",
		radarPublicKey: ""
	}),
	withMethods((store) => ({
		setGeneralState(state: GeneralState): void {
			localStorage.setItem("STRIPE_PUBLIC", state.stripePublicKey);
			Radar.initialize(state.radarPublicKey);
			patchState(store, state)
		}
	}))
)
